<template>
    <Popup
            v-model="popupShow"
            position="bottom"
            radius="5px"
            class="select-device-event-popup"
    >
        <div class="popup-bar">
            <div class="cancel" @click="onCancel">取消</div>
            <div class="title">请选择触发事件</div>
            <div class="ok" @click="onOk">确定</div>
        </div>
        <div class="content">
            <List
                    style="height: 100%;margin-top:-5px;padding: 5px 12px"
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    loading-text="拼命加载中..."
                    :offset="50"
                    :immediate-check="true"
            >
                <div v-for="(item, index) in eventList" :key="index"
                     @click="onSelect(item)"
                     :class="{'event-item':true,'selected':selected.id==item.id} ">
                    <!--<img :src="getImgUrl(item.productImage1)"/>-->
                    <div class="right">{{item.name}}
                    </div>
                </div>
            </List>
        </div>
    </Popup>
</template>

<script>
    import {List, Popup, PullRefresh, Sticky} from "vant"
    import {downloadImg} from "@/config"

    export default {
        components: {
            Popup, PullRefresh, List, Sticky
        },
        props: {
            show: {type: Boolean, default: false},
            deviceId: {type: String, default: ''},
            productVersionId: {type: String, default: ''},
        },
        data() {
            return {
                finished: false,
                loading: false,
                eventList: [],
                selected: {}
            }
        },
        computed: {
            popupShow: {
                get() {
                    return this.show
                },
                set() {
                    this.onCancel()
                }
            },
        },
        methods: {
            onCancel() {
                this.$emit('cancel')
            },
            onOk() {
                this.$emit('ok', this.selected)
            },
            onLoad() {
                this.$http.tokiot.device.product.event.list({
                    id: this.deviceId
                })
                    .then(eventList => {
                        if (eventList) {
                            this.eventList = eventList;
                            this.loading = false;
                            this.finished = true;
                        }
                    })
            },
            search() {
                this.onLoad();
            },
            getImgUrl(url) {
                return downloadImg + url
            },
            onSelect(device) {
                this.selected = device
            }
        },
        watch: {
            deviceId(deviceId) {
                deviceId && this.search()
            }
        }
    };
</script>
<style lang="less" scoped>
    .select-device-event-popup {
        height: calc(100% - 140px);
        & > .content {
            display: flex;
            flex-direction: column;
            height: calc(100% - 50px);
            overflow-y: auto;

        }
    }

    .event-item {

        &.selected {
            border: 1px solid rgba(24, 144, 255, 1);
        }
        padding: 5px;
        display: flex;
        border-radius: 5px;
        border: 1px solid rgba(111, 111, 111, 0.3);
        margin-top: 2px;
        margin-bottom: 5px;
        & > img {
            height: 25px;
            width: 25px;
        }
        & > .right {
            margin-left: 8px;
            line-height: 1.5;
        }
    }
</style>
